import API from "./index"

class GrupoProdutoService {
  constructor() {
    this.path = `api/grupos-produto`
  }

  async findAll({
    page = 0,
    size = 10,
    filter = "",
    isOrOperation = "",
    params = {},
  }) {
    page = page - 1 < 0 ? 0 : page - 1
    params.page = page
    params.size = size

    if (filter) {
      params.filter = filter
    }

    if (isOrOperation) {
      params.isOrOperation = isOrOperation
    }

    try {
      const response = await API.get(this.path, { params })


      const { data } = response

      if (Array.isArray(data.content)) {
        this.records = data.content
      } else {
        this.records = []
      }

      this.total = data.totalElements || 0
      this.totalPage = data.totalPages || 0
      this.page = data.pageable.pageNumber + 1

      return data
    } catch (error) {
      throw new Error("Failed to load resource")
    } finally {
      this.busy = false
    }
  }

  find() {
    return API.get(`${this.path}`)
  }

  findById(id) {
    return API.get(`${this.path}/${id}`)
  }

  async alteraSituacao({ id, situacao }) {
    return await API.put(`${this.path}/${id}/situacao`, { situacao }).then(
      ({ ...args }) => ({ created: false, ...args })
    )
  }

  findByIdWithSubgrupos(id) {
    return API.get(`${this.path}/${id}/subgrupos`)
  }

  async save(record) {
    if (record.id) {
      return await API.put(`${this.path}/${record.id}`, record).then(
        ({ ...args }) => ({ created: false, ...args })
      )
    }
    return await API.post(this.path, record).then(({ ...args }) => ({
      created: true,
      ...args,
    }))
  }

  remove(idGrupo) {
    if (!idGrupo) {
      throw new Error("Grupo não encontrado para o subgrupo")
    }
    return API.delete(`${this.path}/${idGrupo}`)
  }
}

export default GrupoProdutoService
